import { Button } from '@sandtech-hub-monorepo/ui-kit';
import {
  DeferralReason,
  WithdrawFromProgramDocument,
} from '@sandtech-hub-monorepo/ehub-client';
import { useMutation } from '@apollo/client';
import { Loader2Icon } from 'lucide-react';
import { ReactComponent as WithdrawIcon } from '../../../assets/Icons/withdraw-icon.svg';
import React from 'react';
import { ProgramEnrollment } from './SelectProgram';

interface WithdrawProgramConfirmationProps {
  description: string;
  reason: DeferralReason;
  onCancel: () => void;
  afterConfirm: () => void;
  programEnrollment: ProgramEnrollment;
}

export const WithdrawProgramConfirmation = ({
  description,
  reason,
  onCancel,
  afterConfirm,
  programEnrollment,
}: WithdrawProgramConfirmationProps) => {
  const [mutate, { loading }] = useMutation(WithdrawFromProgramDocument, {
    variables: {
      input: {
        programEnrollmentId: programEnrollment.id,
        withdrawalReason: reason,
        withdrawalDescription: description || undefined,
      },
    },
    onCompleted: () => {
      afterConfirm();
    },
  });

  return (
    <div className="max-w-[620px]">
      <div className="px-0 sm:px-16">
        <div className="flex flex-col items-center text-center gap-2">
          <div
            className={`p-6 bg-destructive/20 rounded-full text-destructive mx-auto mb-2`}
          >
            <WithdrawIcon height="48" width="48" />
          </div>
          <h2 className={`text-destructive font-semibold sm:text-2xl text-xl`}>
            Please confirm
          </h2>
          <div className="text-xl">
            You are opting to withdraw from your ALX program
          </div>
        </div>
        <div className="border-b-primary/20 my-8 pb-8 border-b">
          <div className="text-center mb-8">
            Withdrawing from your program will send it permanently. You will
            need to reapply.
          </div>
          <div className="text-center">
            Are you sure you want to withdraw from this program?
          </div>
        </div>
        <div className="flex gap-6 justify-center">
          <Button
            variant="outlineDestructive"
            onClick={() => mutate()}
            disabled={loading}
          >
            {loading ? <Loader2Icon className="animate-spin" /> : 'Confirm'}
          </Button>
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    </div>
  );
};
